export default __webpack_public_path__ + "static/media/ProLeit.68094f52.png";